import styled from "styled-components";

const PageLayout = styled.div`
  height: auto;
  min-height: calc(100vh - 50px - 60px);
  max-width: 1300px;
  width: 90%;
  min-width: 1100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--color-white);
  margin-top: 50px;
  padding: 30px;
`;

const BackgroundLayout = styled.div`
  width: calc(100% - 40px);
  gap: 10px;
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: var(--color-background);
`;

const RowLayout = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const RowEndLayout = styled(RowLayout)`
  justify-content: flex-end;
`;

const RowStartLayout = styled(RowLayout)`
  justify-content: flex-start;
`;

const ColumnLayout = styled.div`
  height: 100%;
  width: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export {
  PageLayout,
  BackgroundLayout,
  RowLayout,
  RowEndLayout,
  RowStartLayout,
  ColumnLayout,
};
